import type { ColorPaletteProp } from '@mui/joy/styles';

export const when = (value: string) =>
  new Date(value).toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
export const label = (value: string) => value.charAt(0).toUpperCase() + value.slice(1).replaceAll('_', ' ');
export const tagColor = (value: string): ColorPaletteProp =>
  (['primary', 'success', 'warning', 'neutral'] as const)[
    Array.from(value).reduce((sum, c) => sum + c.charCodeAt(0), 0) % 4
  ];
